import React from "react";
import { Circle, Container, Text } from "./styles";
export var OrderStatusTag = function (_a) {
    var text = _a.text, color = _a.color, reversed = _a.reversed, width = _a.width;
    return (React.createElement(Container, { color: color, reversed: reversed, width: width },
        React.createElement(Circle, { color: color, reversed: reversed }),
        React.createElement(Text, { reversed: reversed }, text)));
};
//# sourceMappingURL=index.js.map